import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    bulkActionPreview: null,
    bulkActionPreviewLoading: false,
    previewToken: 0,
    startBulkActionLoading: false,
    bulkActionResult: null,
    bulkActionWarningMessage: null,
    bulkActionErrorMessage: null,
};

const pathwayBillingBulkActionSlice = createSlice({
    name: "PathwayBillingBulkAction",
    initialState,
    reducers: {
        resetBulkAction(state) {
            state.bulkActionPreview = null;
            state.bulkActionPreviewLoading = false;
            state.previewToken = 0;
            state.startBulkActionLoading = false;
            state.bulkActionResult = null;
            state.bulkActionWarningMessage = null;
            state.bulkActionErrorMessage = null;
        },
        previewBulkActionRequest(state, action) {
            state.bulkActionPreviewLoading = true;
            state.bulkActionPreview = null;
            state.bulkActionErrorMessage = null;
            state.previewToken = action.payload;
        },
        previewBulkActionSuccess(state, action) {
            if (action.payload.token !== state.previewToken) {
                return;
            }
            state.bulkActionPreviewLoading = false;
            state.bulkActionPreview = action.payload.preview;
        },
        previewBulkActionFailure(state, action) {
            if (action.payload.token !== state.previewToken) {
                return;
            }
            state.bulkActionPreviewLoading = false;
            state.bulkActionErrorMessage = action.payload.error;
        },
        startBulkActionRequest(state) {
            state.startBulkActionLoading = true;
            state.bulkActionErrorMessage = null;
        },
        startBulkActionSuccess(state, action) {
            state.startBulkActionLoading = false;
            state.bulkActionResult = action.payload.result;
            state.bulkActionWarningMessage = action.payload.warningMessage;
        },
        startBulkActionFailure(state, action) {
            state.startBulkActionLoading = false;
            state.bulkActionErrorMessage = action.payload;
        },
    },
});

export default pathwayBillingBulkActionSlice;
